import type { IPost } from "../../../../types/models/post.models.types";
import { useGetHttp } from "../../http.hook";

export interface IPostResponse {
  posts: Array<IPost>;
}

export function useSearchPostsEphemeralHttp() {
  return useGetHttp<IPostResponse>({
    path: "/ephemeral/brand-dash/posts/search",
  });
}
